import * as Yup from "yup";

export const createEntityInformationInputSchema = Yup.object().shape({
  legalBusinessName: Yup.string().required("Legal business name is required").default(""),
  entityType: Yup.string().required("Entity type is required").default(""),
  dateOfFormation: Yup.date()
    .required("Date of formation is required")
    .max(new Date(), "Date of formation must be in the past"),
  identificationNumber: Yup.string()
    .required("Identification number is required")
    .min(4, "Identification number must be at least 4 digits"),
});
